import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketDetailComponent } from '../_template/ticket-detail/ticket-detail.component';
import { CrmDetailComponent } from '../_template/crm-detail/crm-detail.component';
import { TicketMoreComponent } from '../_template/ticket-more/ticket-more.component';
import { IonicModule } from '@ionic/angular';
import { TicketDetailAllgemeinComponent } from '../_template/ticket-more/ticket-detail-allgemein/ticket-detail-allgemein.component';
import { TicketDetailZeitenComponent } from '../_template/ticket-more/ticket-detail-zeiten/ticket-detail-zeiten.component';
import { TicketComponent } from '../_template/ticket/ticket.component';
import { TicketDetailAssetsComponent } from '../_template/ticket-more/ticket-detail-assets/ticket-detail-assets.component';
import { TicketDetailWorkersComponent } from '../_template/ticket-more/ticket-detail-workers/ticket-detail-workers.component';
import { TicketBaseHomeComponent } from '../_template/ticket-base-home/ticket-base-home.component';
import { AssetsAddComponent } from '../_template/ticket-more/ticket-detail-assets/assets-add/assets-add.component';
import { WorkstepContentComponent } from '../_template/ticket-detail/workstep-content/workstep-content.component';
// import { QuillModule } from 'ngx-quill';
import { FormsModule } from '@angular/forms';
import { SafeHtmlPipe } from '../_pipes/SafeHtml.Pipe';
import { FormatTime, SecondsToTimeString, TaskName, timeDifference, timeIntervalDifference } from '../_pipes/timeDifference.Pipe';
import { ScrollbarDirective } from '../_directives/scrollbar.directive';
import { TicketSortPipe, TicketSortState } from '../_pipes/ticket-sort.pipe';
import { AppointmentComponent } from '../_template/ticket-more/ticket-detail-allgemein/appointment/appointment.component'
import { ToCalculateNameById } from '../_pipes/toCalculate.pipe';
import { TreeViewChildren, TreeViewSearch } from '../_pipes/treeview.pipe';
import { TicketStateColor, TicketStateDescription, TicketStateIcon } from '../_pipes/TicketState.pipe';
import { TimeOverviewComponent } from "../_template/time-overview/time-overview.component"
import { AttachmentDownloadedIcon, AttachmentIcon, AttachmentIconByFile, FileSizeFormat } from '../_pipes/attachmentIcon.pipe';
import { QuickSearchComponent } from '../_template/quick-search/quick-search.component';
import { TimeOverviewBaseItemComponent } from '../_template/time-overview/time-overview-base/time-overview-base-item/time-overview-base-item.component';
import { LongPressDirective } from '../_directives/LongPress.directive';
import { FullscreenModalComponent } from '../_template/fullscreen-modal/fullscreen-modal.component';
import { DynamicComponents } from '../_directives/dynamic-component.directive';
import { BreadcrumpHeaderComponent } from '../_template/fullscreen-modal/breadcrump-header/breadcrump-header.component';
import { ArrowKeyUseable } from '../_directives/ArrowKeysUseable.directive';
import { ContentEditPopupPage } from '../_template/ticket-detail/content-edit-popup/content-edit-popup.page';
import { UserlistComponent } from '../_template/ticket-detail/content-edit-popup/userlist/userlist.component';
import { UserInformationComponent } from '../_template/ticket-detail/workstep-content/user-information/user-information.component';
import { CuNavigationComponent } from '../_template/customer/cu-navigation/cu-navigation.component';
import { CuDetailsComponent } from '../_template/customer/cu-details/cu-details.component';
import { CuMainComponent } from '../_template/customer/cu-main/cu-main.component';
import { TicketEmployees, TicketGroups } from '../_pipes/TicketEmployees.pipe';
import { DropZoneComponent } from '../_template/drop-zone/drop-zone.component';
import { AssetItemComponent } from '../_template/ticket-more/ticket-detail-assets/asset-item/asset-item.component';
import { TimeAmountSelectComponent } from '../_template/ticket-more/ticket-detail-allgemein/time-amount-select/time-amount-select.component';
import { NotificationStartComponent } from '../_template/notification-start/notification-start.component';
import { UpgradeGuideComponent } from '../_pages/new-features/upgrade-guide/upgrade-guide.component';
import { EditorViewComponent } from '../_template/ticket-more/ticket-detail-allgemein/editor-view/editor-view.component';
import { ServerCompatibilityComponent } from '../_interfaces/navigation/server-compatibility/server-compatibility.component';
import { OrderBy } from '../_pipes/OrderBy.pipe';
import { TagAssignInputComponent } from '../_template/ticket-detail/tag-assign-input/tag-assign-input.component';
import { TicketFilterComponent } from '../home/ticket-filter/ticket-filter.component';
import { TicketSortComponent } from '../home/ticket-sort/ticket-sort.component';
import { ClickOutsideDirective } from '../_directives/clickOutside.directive';
import { EmailTagsInputComponent } from '../_template/ticket-detail/content-edit-popup/email-tags-input/email-tags-input.component';
import { CheckboxSelectComponent } from '../_template/checkbox-select/checkbox-select.component';
import { SocketTicketUsersComponent } from '../_template/ticket-detail/socket-ticket-users/socket-ticket-users.component';
import { SwipeBackDirective } from '../_directives/swipeback.directive';
import { HoverTitleDirective } from '../_directives/hover-title.directive';
import { TimelineComponent } from '../_template/ticket-more/ticket-detail-zeiten/timeline/timeline.component';
import { DeliverStopOverlayComponent } from '../_template/ticket-detail/deliver-stop-overlay/deliver-stop-overlay.component';
import { AddressArtTagColorPipe, AddressArtTagText } from '../_pipes/AddressArt.pipe';
import { TicketDetailAppointmentsComponent } from '../_template/ticket-more/ticket-detail-appointments/ticket-detail-appointments.component';
import { TicketDetailAppointmentItemComponent } from '../_template/ticket-more/ticket-detail-appointments/ticket-detail-appointment-item/ticket-detail-appointment-item.component';
import { ClosedMenuComponent } from '../_interfaces/navigation/closed-menu/closed-menu.component';
import { SubscriptionBannerComponent } from '../_interfaces/navigation/subscription-banner/subscription-banner.component';
import { ProcessListComponent } from '../_template/crm-detail/process-list/process-list.component';
import { TicketArtPipe } from '../_pipes/TicketArt.pipe';

@NgModule({
  declarations: [
    TicketDetailComponent, 
    TicketFilterComponent,
    TicketSortComponent,
    CrmDetailComponent, 
    TicketMoreComponent, 
    SafeHtmlPipe,
    timeDifference,
    SecondsToTimeString,
    TaskName,
    timeIntervalDifference,
    FormatTime,
    TicketStateDescription,
    TicketStateColor,
    TicketStateIcon,
    TreeViewChildren,
    TreeViewSearch,
    ToCalculateNameById,
    AppointmentComponent,
    TicketSortPipe,
    TicketSortState,
    AttachmentIcon,
    AttachmentDownloadedIcon,
    TicketDetailAllgemeinComponent,
    TicketDetailAppointmentsComponent,
    TicketDetailZeitenComponent,
    TicketDetailAppointmentItemComponent,
    TicketDetailWorkersComponent,
    TicketDetailAssetsComponent,
    TicketComponent,
    WorkstepContentComponent,
    AssetsAddComponent,
    TicketBaseHomeComponent,
    ScrollbarDirective,
    TimeOverviewComponent,
    QuickSearchComponent,
    ClosedMenuComponent,
    TimeOverviewBaseItemComponent,
    LongPressDirective,
    DynamicComponents,
    BreadcrumpHeaderComponent,
    FullscreenModalComponent,
    ArrowKeyUseable,
    ClickOutsideDirective,
    ContentEditPopupPage,
    UserlistComponent,
    UserInformationComponent,
    CuNavigationComponent,
    CuDetailsComponent,
    CuMainComponent,
    TicketEmployees,
    TicketGroups,
    AssetItemComponent,
    EditorViewComponent,
    DropZoneComponent,
    TimeAmountSelectComponent,
    NotificationStartComponent,
    UpgradeGuideComponent,
    ServerCompatibilityComponent,
    OrderBy,
    EmailTagsInputComponent,
    TagAssignInputComponent,
    AttachmentIconByFile,
    FileSizeFormat,
    SocketTicketUsersComponent,
    CheckboxSelectComponent,
    SwipeBackDirective,
    HoverTitleDirective,
    TimelineComponent,
    DeliverStopOverlayComponent,
    AddressArtTagColorPipe,
    AddressArtTagText,
    SubscriptionBannerComponent,
    ProcessListComponent,
    TicketArtPipe
  ],
  imports: [CommonModule, IonicModule, FormsModule ],//QuillModule.forRoot()],
  exports: [
    TicketDetailComponent, 
    TicketFilterComponent,
    TicketSortComponent,
    SafeHtmlPipe,
    timeDifference,
    SecondsToTimeString,
    TaskName,
    timeIntervalDifference,
    FormatTime,
    TicketStateDescription,
    TicketStateColor,
    TicketStateIcon,
    TreeViewChildren,
    TreeViewSearch,
    ToCalculateNameById,
    AppointmentComponent,
    CrmDetailComponent,
    AssetsAddComponent,
    WorkstepContentComponent,
    TicketMoreComponent, 
    AttachmentIcon,
    AttachmentDownloadedIcon,
    TicketDetailAllgemeinComponent,
    TicketDetailAppointmentsComponent,
    TicketDetailAppointmentItemComponent,
    TicketDetailZeitenComponent,
    TicketDetailAssetsComponent,
    SubscriptionBannerComponent,
    TicketDetailWorkersComponent,
    TicketBaseHomeComponent,
    TicketComponent,
    ClosedMenuComponent,
    ScrollbarDirective,
    TicketSortPipe,
    TicketSortState,
    TimeOverviewComponent,
    QuickSearchComponent,
    LongPressDirective,
    TimeOverviewBaseItemComponent,
    FullscreenModalComponent,
    BreadcrumpHeaderComponent,
    DynamicComponents,
    ArrowKeyUseable,
    ClickOutsideDirective,
    ContentEditPopupPage,
    UserlistComponent,
    UserInformationComponent,
    CuNavigationComponent,
    CuDetailsComponent,
    CuMainComponent,
    EditorViewComponent,
    TicketEmployees,
    TicketGroups,
    AssetItemComponent,
    DropZoneComponent,
    TimeAmountSelectComponent,
    NotificationStartComponent,
    UpgradeGuideComponent,
    ServerCompatibilityComponent,
    OrderBy,
    EmailTagsInputComponent,
    TagAssignInputComponent,
    AttachmentIconByFile,
    FileSizeFormat,
    SocketTicketUsersComponent,
    CheckboxSelectComponent,
    SwipeBackDirective,
    HoverTitleDirective,
    TimelineComponent,
    DeliverStopOverlayComponent,
    AddressArtTagColorPipe,
    AddressArtTagText,
    ProcessListComponent,
    TicketArtPipe
  ],
  providers: [
    timeIntervalDifference,
    SafeHtmlPipe
  ]
})
export class ComponentsModule { }
